
/**
 * @import internal modules
 */

/**
 * @import external modules
 */

import * as React from "react";
import { pure } from 'recompose';



// component
const Component: React.FunctionComponent<any> = (props: InterfaceCopyright<string>): JSX.Element =>{
    
    const { classnames } = props;

    return(
        <div className={classnames} > <strong> Cyclope.ai ,&nbsp; &copy; 2019</strong> </div>
    )
}
// interface 
export interface InterfaceCopyright<T>{
    classnames: T,
}
/**
 * DefaultProps values
 */
Component.defaultProps= {

}


export default pure(Component);


// WEBPACK FOOTER //
// ./src/apps/components/@widgets/copyright/component.tsx